export default "__VITE_ASSET__7e3ea149__"